// @ts-nocheck
import * as React from 'react';
import { AgGridReact } from 'ag-grid-react';
import Formatters from '../../../actions/Formatters';
import $ from 'jquery';

import { RCUtils } from './../../../RCUtils';
import { GridToolBarPopups } from './../../sharedcomponents/GridToolBarPopups';
// pull in the ag-grid styles we're interested in
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-fresh.css';
import 'react-datepicker/dist/react-datepicker.css';
import TripCancel from '../../../images/TripCancel.png';
var Config: any = require('../../../Config.json');

interface VCCheckBoxData {
    enableVCCheckBox: boolean;
    disableVCCheckBoxOption: boolean;
    disableVCDropDown: boolean;
    disableVCOption: boolean;
    selectedVCData: server.VesselInformation;
    dropDownVCData: server.VesselInformation[];
    isVCMessage: boolean;
}
const emptyVCCheckBoxData: VCCheckBoxData = { enableVCCheckBox: false, disableVCCheckBoxOption: false, disableVCDropDown: false, disableVCOption: false, selectedVCData: null, dropDownVCData: [], isVCMessage:false };

export interface ScheduledPreTripGridState {
    SelectedReefers: any[];
    rowData: server.USP_GetScheduledPretripDetails_Result[];
    columnDefs: any[];
    Filters: ForwardCommandParams;
    VCCheckBoxInfo: VCCheckBoxData;
    GridToolBarHtml: any;
}

var colDefs;
var self;
var cancelEvent;
export class ScheduledPreTrip extends React.Component<any, ScheduledPreTripGridState> {
    constructor(props: any) {
        super(props);
        var filterSet = new ForwardCommandParams();
        this.state = { SelectedReefers: [], rowData: [], columnDefs: [], Filters: filterSet, VCCheckBoxInfo: emptyVCCheckBoxData, GridToolBarHtml:'' };
        colDefs = this.createColumnDefs();
        self = this;
    }

    componentDidMount() {
        this.renderGridToolBar();
       
       
        
        

        var reeferData = this.props.reeferData;
        if (reeferData.length > 0) {
            if (reeferData != undefined && reeferData != null) {
                this.setState({ SelectedReefers: reeferData });
                $('#globalLoader').show();
                this.GetDataFromAPI(reeferData);
            }
        }

        if (this.props.VCCheckBoxInfo != undefined && this.props.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: this.props.VCCheckBoxInfo });
        }       
    }

    componentWillReceiveProps(nextprops: any) {
        var reeferData = nextprops.reeferData;
        if (reeferData.length > 0) {
            if (reeferData != undefined && reeferData != null) {
                this.setState({ SelectedReefers: reeferData });
                $('#globalLoader').show();
                this.GetDataFromAPI(reeferData);
            }
        } 
        if (nextprops.VCCheckBoxInfo != undefined && nextprops.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: nextprops.VCCheckBoxInfo });
        }
    }

    renderGridToolBar() {
        this.setState({ GridToolBarHtml: this.renderGridToolBarHtml() });
    }

    renderGridToolBarHtml() {
        return <GridToolBarPopups refreshGrid={this.refreshGrid.bind(this)} gridData={this.state.rowData} colDefs={colDefs} parentchild={"P"} formName={"SchedulePreTrip"} VCCheckBoxInfo={this.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={this.UpdateVCCheckBoxInfo.bind(this)} />;
    }

    GetDataFromAPI(reeferData) {
        self.state.Filters.SelectedReefers = reeferData;
        var forwardCommandParams = JSON.stringify(self.state.Filters);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/LoadScheduledPTIData', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.USP_GetScheduledPretripDetails_Result[]>)
            .then(data => {
                this.setState({ rowData: data }, ()=> this.renderGridToolBar());
                $('#globalLoader').hide();
            });
    }
    //*-----Start Grid Related-----*//

    onGridReady(params: any) {
        params.api.gridOptionsWrapper.gridOptions.suppressContextMenu = true;
        //this.gridApi.forEachNode(node => node.rowIndex ? 0 : node.setSelected(true));
    }

    refreshGrid = () => {
        $('#globalLoader').show();
        this.GetDataFromAPI(this.state.SelectedReefers);
        $('#globalLoader').hide();
    };

    //removeIndicator(params: any) {
    //    var element = document.createElement("span");
    //    element.className = "reefer-delete";

    //    var imageElement = document.createElement("img");
    //    imageElement.src = TripCancel;
    //    imageElement.title = "Cancel";
    //    element.appendChild(imageElement);
    //    return element;
    //}
    removeIndicator(params: any) {
        return <span className="reefer-delete"><img src={TripCancel} title='Cancel'></img></span>;
    }
    onCellClickedCancel(event) {
        cancelEvent = null;
        cancelEvent = event;
        $('#pretripCancelModal').show();
    }

    CancelAction() {
        self.Delete(cancelEvent);
        $("#pretripCancelModal").hide();
    }

    Delete(params:any) {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/SubmitScheduledPTIData', { method: 'POST', body: JSON.stringify(params.data), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response)
            .then(data => {
                self.closeConfirmation();
            });
        params.api.gridOptionsWrapper.gridOptions.rowData.splice(params.rowIndex, 1);
        params.api.setRowData(params.api.gridOptionsWrapper.gridOptions.rowData);
        self.closeConfirmation();
        //RCNGWindow.ConfirmWindow.close();    
    }

    closeConfirmation(){
         $("#pretripCancelModal").hide();
    }

    NoConfirmation(){
        self.closeConfirmation();
    }

    createColumnDefs() {
        return [
            { headerName: "Cancel", field: "CommandTypeCd", cellRenderer: this.removeIndicator, onCellClicked: this.onCellClickedCancel.bind(this),width: 85 },
            { headerName: "Reefer ID", field: "ReeferID", width: 140 },
            { headerName: "Device ID", field: "RCDID", width: 150 },
            { headerName: "Time window start", field: "StartDate", cellRenderer: Formatters.dateTypeFormatter, width: 150 },
            { headerName: "Time window end", field: "EndDate", cellRenderer: Formatters.dateTypeFormatter, width: 150 },
            { headerName: "Geofence", field: "GeofenceCustomerID", width: 100 },
            { headerName: "Created time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "scheduledCreatedDTTM", cellRenderer: Formatters.dateTypeFormatter, width: 150 },
            { headerName: "Pretrip type", field: "CommandText", width: 150 },
        ];

    }

    //*-----End Grid Related-----*//

    UpdateVCCheckBoxInfo(VCInfo: any) {
        if (this.props.UpdateVCCheckBoxInfo != null && this.props.UpdateVCCheckBoxInfo != 'undefined')
            this.props.UpdateVCCheckBoxInfo(VCInfo);
    } 

    public render() {
        return <div>
            <div>
                {this.state.GridToolBarHtml}
            </div>
            <div className="ag-theme-fresh containerstyle_commands">
                <AgGridReact
                    columnDefs={colDefs}
                    rowData={this.state.rowData}
                    onGridReady={this.onGridReady}
                    pagination={true}
                    accentedSort={true}
                    paginationPageSize={25}>
                </AgGridReact>
            </div>         
            <div className="modal" id="pretripCancelModal" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Confirmation </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={this.closeConfirmation.bind(this)}>&times;</button>
                           
                        </div>
                        <div className="modal-body">
                           Do you want to cancel the scheduled pretrip?
                        </div>
                        <div className="modal-footer">
                            <button type="button" id="hidePopUpBtn" className="btn btn-secondary" onClick={this.NoConfirmation.bind(this)} >No</button>
                            <button type="button" id="btnYes" className="btn btn-primary" onClick={this.CancelAction.bind(this)}>Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}

class ForwardCommandParams {
    SelectedReefers: server.USP_UnitCurrentConditionUI_Model[];
    CommandName: string;
    TempValue: any;
}